import React, { useEffect, useState } from "react";
import "./RegisterScreen.css";
import GlobalBackground from "../../components/GlobalBackground/GlobalBackground";
import { data, Link, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../redux/store/store";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import FormInputs from "../../components/FormInputs/FormInputs";
import { City, Country, State } from "country-state-city";
import CustomDropdown from "../../components/CustomerDropdown/CustomerDropdown";
// import { registerUser } from "../../api/apiServices";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../utils/ToastMessages/ToastMessages";
import CommonLoginToHeader from "../../components/CommonLoginToHeader/CommonLoginToHeader";
import { handleCopyPaste } from "../../utils/PreventDefault/PreventDefault";
import {
  pinpointStatus,
  unAuthAddressDetails,
} from "../../redux/slices/authSlice";
import { registerAuthUser, registerUser } from "../../api/apiServices";
import Loader from "../../components/Loader/Loader";
import { address, city, country, email, fullName, mapLink, mobileNumber, password, pinCode, state } from "../../utils/regexData";

const RegisterScreen: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [selectedState, setSelectedState] = useState<any>(null);
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [isCountry, setIsCountry] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const isFirstPinpoint = useSelector(
    (state: RootState) => state?.auth.isFirstPinPoint
  );
  const unAuthAddress = useSelector(
    (state: RootState) => state?.auth.unAuthAddress
  );
  const userDetails = useSelector(
    (state: RootState) => state?.auth.userDetails
  );

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  }: any = useForm();
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    if (!isFirstPinpoint) {
      setValue("fullname", unAuthAddress.name);
      setValue("mobile", unAuthAddress.username);
      setValue("email", unAuthAddress.email);
    }
    if (token) {
      setValue("fullname", userDetails.name);
      setValue("mobile", userDetails.username);
      setValue("email", userDetails.email);
    }
  }, [isFirstPinpoint, unAuthAddress]);

  useEffect(() => {
    const handlePopState = () => {
      sessionStorage.removeItem("unAuthAddress");
      if (token && token !== "undefined") {
        dispatch(pinpointStatus(false));
      } else {
        dispatch(pinpointStatus(true));
        dispatch(unAuthAddressDetails(""));
      }
      navigate("/");
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  // Convert data into the format required by react-select
  const countryOptions = Country.getAllCountries().map((country: any) => ({
    value: country.isoCode,
    label: country.name,
  }));

  const stateOptions = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state: any) => ({
        value: state.isoCode,
        label: state.name,
      }))
    : [];

  const cityOptions = selectedState
    ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
        (city) => ({
          value: city.name,
          label: city.name,
        })
      )
    : [];

  const registerHandler = async (data: any) => {
    console.log('clicked------------->>>')
    setIsDisabled(true);
    try {
      const bodyObject = {
        username: data.mobile,
        email: data.email,
        name: data.fullname,
        flat_details: data.flat,
        area: data.area,
        landmark: data.landmark,
        city: data.city,
        state: data.state,
        country: data.country,
        map_link: data.map,
        password: data.password,
        pin_code: data.pincode,
      };

      // dispatch(pinpointStatus(false));
      //           sessionStorage.setItem('unAuthAddress', newPin);
      //           await navigate("/pinpoint");
      if (token && token !== "undefined") {
        const registerResponse: any = await registerAuthUser(bodyObject, token);
        if (registerResponse?.status) {
          await navigate("/home");
          showSuccessToast(registerResponse?.message);
          setIsDisabled(false);
        } else {
          showErrorToast(
            registerResponse?.error?.username[0] ||
              "Please enter valid password!"
          );
          setIsDisabled(false);
        }
      } else {
        if (isFirstPinpoint) {
          if (data.password === data.reenterPassword) {
            const registerResponse: any = await registerUser(bodyObject);
            if (registerResponse?.status) {
              const newPin = JSON.stringify(registerResponse.data);
              sessionStorage.setItem("unAuthAddress", newPin);
              await navigate("/pinpoint");
              showSuccessToast(registerResponse?.message);
              const newUserData: any = registerResponse.data;
              dispatch(unAuthAddressDetails(newUserData));
              dispatch(pinpointStatus(false));
              setIsDisabled(false);
            } else {
              showErrorToast(
                registerResponse?.error?.username[0] ||
                  "Please enter valid password!"
              );
              setIsDisabled(false);
            }
          } else {
            showWarningToast("Please enter valid password!");
          }
        } else {
          const registerResponse: any = await registerUser(bodyObject);
          if (registerResponse?.status) {
            const newPin = JSON.stringify(registerResponse.data);
            sessionStorage.setItem("unAuthAddress", newPin);
            await navigate("/pinpoint");
            showSuccessToast(registerResponse?.message);
            setIsDisabled(false);
          } else {
            showErrorToast(
              registerResponse?.error?.username[0] ||
                "Registration failed, please enter valid data!"
            );
            setIsDisabled(false);
          }
        }
      }
    } catch (error: any) {
      showErrorToast(error?.response?.data?.error || "Registration failed!");
      setIsDisabled(false);
      // showErrorToast("Registration failed, please enter valid data!");
    }
  };

  const passwordVisibilityHandler = () => {
    setShowPassword(!showPassword);
  };

  const confirmPasswordVisibilityHandler = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <GlobalBackground>
      <div className="register-outer-container">
        <CommonLoginToHeader
          title={"PinPoint Addresses"}
          screen={""}
          backScreen={""}
        />

        <div className="register-form-container">
          <h2>New PinPoint Account</h2>

          <form onSubmit={handleSubmit(registerHandler)}>
            {/* Full name */}
            <FormInputs
              maxLength={80}
              type={"text"}
              register={register}
              placeholder={"Full Name"}
              name={"fullname"}
              required={"Full name is required"}
              pattern={fullName}
              message={"Enter a valid name"}
              errors={errors}
              prevent={() => {}}
              disabled={!isFirstPinpoint}
            />
            {/* Mobile number */}
            <FormInputs
              maxLength={10}
              type={"tel"}
              register={register}
              placeholder={"10 Digit Mobile Number"}
              name={"mobile"}
              required={"Mobile number is required"}
              pattern={mobileNumber}
              message={"Enter a valid 10-digit mobile number"}
              errors={errors}
              prevent={() => {}}
              disabled={!isFirstPinpoint}
            />

            {/* Mobile number */}
            <FormInputs
              maxLength={250}
              type={"email"}
              register={register}
              placeholder={"Email Address"}
              name={"email"}
              required={"Email is required"}
              pattern={email}
              message={"Enter a valid email address"}
              errors={errors}
              prevent={() => {}}
              disabled={!isFirstPinpoint}
            />

            <hr className="register-hr" />

            {/* Flat */}
            <FormInputs
              maxLength={100}
              type={"text"}
              register={register}
              placeholder={"Flat or House Number, Building Name"}
              name={"flat"}
              required={"Flat or house number, building name is required"}
              pattern={address}
              message={"Enter a valid flat or house number or building name"}
              errors={errors}
              prevent={() => {}}
              disabled={false}
            />

            {/* Area */}
            <FormInputs
              maxLength={100}
              type={"text"}
              register={register}
              placeholder={"Area, Street, Sector, Village"}
              name={"area"}
              required={"Area, street, sector, village is required"}
              pattern={address}
              message={"Enter a valid area or street or sector or village"}
              errors={errors}
              prevent={() => {}}
              disabled={false}
            />

            {/*Landmark  */}
            <FormInputs
              maxLength={100}
              type={"text"}
              register={register}
              placeholder={"Nearest Landmark"}
              name={"landmark"}
              required={"Nearest landmark is required"}
              pattern={address}
              message={"Enter a valid nearest landmark"}
              errors={errors}
              prevent={() => {}}
              disabled={false}
            />

            {/* Country */}
            <CustomDropdown
              maxLength={80}
              type={"text"}
              register={register}
              placeholder={"Country"}
              name={"country"}
              required={"Country is required"}
              pattern={country}
              message={"Enter a valid country"}
              errors={errors}
              dataList={countryOptions}
              setValue={setValue}
              setIsCountry={setIsCountry}
              isDisabled={false}
              setData={setSelectedCountry}
              setState={setSelectedState}
              setCity={setSelectedCity}
              selectedOption={"country"}
              getValues={getValues}
            />

            {/* State */}
            <CustomDropdown
              maxLength={80}
              type={"text"}
              register={register}
              placeholder={"State"}
              name={"state"}
              required={"State is required"}
              pattern={state}
              message={"Enter a valid state"}
              errors={errors}
              dataList={stateOptions}
              setValue={setValue}
              setIsCountry={null}
              isDisabled={!isCountry}
              setData={setSelectedState}
              setState={null}
              setCity={setSelectedCity}
              selectedOption={"state"}
              getValues={getValues}
            />

            {/* City */}
            <CustomDropdown
              maxLength={80}
              type={"text"}
              register={register}
              placeholder={"City"}
              name={"city"}
              required={"City is required"}
              pattern={city}
              message={"Enter a valid city"}
              errors={errors}
              dataList={cityOptions}
              setValue={setValue}
              setIsCountry={null}
              isDisabled={!selectedState}
              setData={setSelectedCity}
              setState={null}
              setCity={null}
              selectedOption={"city"}
              getValues={getValues}
            />

            {/* Pincode */}
            <FormInputs
              maxLength={10}
              type={"tel"}
              register={register}
              placeholder={"Pincode"}
              name={"pincode"}
              required={"Pincode is required"}
              pattern={pinCode}
              message={"Enter a valid pincode"}
              errors={errors}
              prevent={() => {}}
              disabled={false}
            />

            {/* Map link */}
            <FormInputs
              maxLength={80}
              type={"text"}
              register={register}
              placeholder={"Map Coordinates Link (Optional)"}
              name={"map"}
              required={false}
              pattern={
                mapLink
              }
              message={"Enter a valid map coordinates link"}
              errors={errors}
              prevent={() => {}}
              disabled={false}
            />

            <hr className="register-hr-bottom" />

            {/* Password */}
            <div className="register-password-container">
              <FormInputs
                maxLength={15}
                type={showPassword ? "default" : "password"}
                register={register}
                placeholder={"Enter Password"}
                name={"password"}
                required={"Password is required"}
                pattern={
                  password
                }
                message={
                  "Password must be 8-15 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character."
                }
                errors={errors}
                prevent={handleCopyPaste}
                disabled={false}
              />
              <div
                onClick={passwordVisibilityHandler}
                className="register-password-visibility"
              >
                {showPassword ? (
                  <img alt="eye" src={require("../../assets/images/eye.png")} />
                ) : (
                  <img
                    alt="closed-eye"
                    src={require("../../assets/images/hidden.png")}
                  />
                )}
              </div>
            </div>

            {/* confirm password */}
            {isFirstPinpoint && (
              <div className="register-password-container">
                <FormInputs
                  maxLength={15}
                  type={showConfirmPassword ? "default" : "password"}
                  register={register}
                  placeholder={"Confirm Password"}
                  name={"reenterPassword"}
                  required={"Reenter your password"}
                  pattern={
                    password
                  }
                  message={
                    "The passwords you entered don’t match. Please check and try again."
                  }
                  errors={errors}
                  prevent={handleCopyPaste}
                  disabled={false}
                />
                <div
                  onClick={confirmPasswordVisibilityHandler}
                  className="register-password-visibility"
                >
                  {showConfirmPassword ? (
                    <img
                      alt="eye"
                      src={require("../../assets/images/eye.png")}
                    />
                  ) : (
                    <img
                      alt="closed-eye"
                      src={require("../../assets/images/hidden.png")}
                    />
                  )}
                </div>
              </div>
            )}

            <div
              // onClick={async () => {
              //   let unAuthData = [{
              //     pinpointNumber: "ASD23E",
              //     name: "Amol M Chaphekar",
              //     number: 9860322222,
              //     flat: "C-204, Rohan Leher,",
              //     area: "Phase 1, Baner",
              //     landmark: "Behind Bitwise Building, Off Mumbai Bangolare Highway",
              //     country: "India",
              //     state: "Maharashtra",
              //     city: "Pune",
              //     pinCode: 411045,
              //   }]
              //   const newPin = JSON.stringify(unAuthData);
              //   dispatch(pinpointStatus(false));
              //   sessionStorage.setItem('unAuthAddress', newPin);
              //   await navigate("/pinpoint");
              // }}
              className="register-button"
            >
              <button disabled={isDisabled} type="submit">
                {isDisabled ? <Loader/> : 'Submit'}
                </button>
            </div>
          </form>
        </div>
      </div>
    </GlobalBackground>
  );
};

export default RegisterScreen;
